import * as React from 'react';

import { WarningOutlined } from '@ant-design/icons';

interface SetNonIdealStateParams {
    isNonIdeal?: boolean;
    header?: React.ReactNode;
    subheader?: React.ReactNode;
    icon?: React.RefAttributes<HTMLSpanElement>;
}

interface UseNonIdealStateReturn {
    isNonIdeal: boolean;
    header: React.ReactNode;
    subheader: React.ReactNode;
    icon: React.RefAttributes<HTMLSpanElement>;
    setNonIdealState: (params: SetNonIdealStateParams) => void;
    resetNonIdealState: () => void;
}

export const useNonIdealState = (): UseNonIdealStateReturn => {

    const [isNonIdeal, setIsNonIdeal] = React.useState(false);
    const [nonIdealHeader, setNonIdealHeader] = React.useState<React.ReactNode>('');
    const [nonIdealSubheader, setNonIdealSubheader] = React.useState<React.ReactNode>('');
    const [nonIdealIcon, setNonIdealIcon] = React.useState<React.RefAttributes<HTMLSpanElement>>(<WarningOutlined />);

    const setNonIdealState = (params: SetNonIdealStateParams): void => {
        setIsNonIdeal(params.isNonIdeal ?? true);
        setNonIdealHeader(params.header ?? '');
        setNonIdealSubheader(params.subheader ?? '');
        setNonIdealIcon(params.icon ?? <WarningOutlined />);
    };

    const resetNonIdealState = (): void => {
        setIsNonIdeal(false);
        setNonIdealHeader('');
        setNonIdealSubheader('');
        setNonIdealIcon(<WarningOutlined />);
    };

    return {
        isNonIdeal: isNonIdeal,
        header: nonIdealHeader,
        subheader: nonIdealSubheader,
        icon: nonIdealIcon,
        setNonIdealState: setNonIdealState,
        resetNonIdealState: resetNonIdealState,
    };
};